export default "__VITE_ASSET__020400b0__"